<template>
  <div class="app-content">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AppContent',
}
</script>

<style scoped>
.app-content {
  width: 100%;
}
</style>
